import firebase from './firebaseBundle'

const logInAppleUser = async () => {
  await firebase.auth().signInWithPopup(new firebase.auth.OAuthProvider('apple.com'))
}

export default logInAppleUser
